import {
  OgpSidebarItems,
  OgpSidebarItemsSource,
  OgpSidebarSection,
} from './ogp-sidebar-items.types';

export const cloneSidebarItems = (sidebarItems: OgpSidebarItemsSource): OgpSidebarItems =>
  sidebarItems.map(
    (section): OgpSidebarSection => ({
      key: section.key,
      name: section.name,
      children: [...section.children],
    })
  );
